<template>
  <div id="stockCheck">
    <div class="mask" v-show="mask"></div>
    <div class="searchBox">
      <div>
        <el-button
          type="primary"
          size="medium"
          @click="(addChekckVisible = true), (mask = true)"
          >新增盘点</el-button
        >
        <el-popover
          placement="bottom"
          width="400"
          v-model="visible"
          popper-class="popover"
          trigger="click"
        >
          <div>
            <div class="lock-stock-title">
              <div>锁定仓库</div>
              <div>
                <img
                  src="../../assets/icon/close.png"
                  @click="closePopover"
                  class="close-img"
                />
              </div>
            </div>
            <div
              class="lock-stock-content"
              v-for="(item, index) in repositoryLists"
              :key="index"
            >
              <div class="flex-row-start">
                <div class="limit">{{ item.repositoryName }}</div>
                <div :class="item.hadLock ? 'stock-lock' : 'stock-not-lock'">
                  {{ item.hadLock }}
                </div>
              </div>
              <div>
                <el-switch
                  v-model="item.lockStockSwitch"
                  @change="lockStockSwitchChange(item, index)"
                ></el-switch>
              </div>
            </div>
          </div>
          <div class="lock-stock" slot="reference">
            <img src="../../assets/icon/lock.png" class="lock-img" />
            <span>锁定仓库</span>
          </div>
          <div class="lock-stock-warn">
            注：仓库锁定期间，系统将不允许进行出入库类业务的操作，盘点后请解锁
          </div>
        </el-popover>

        <el-input
          style="width:200px"
          placeholder="输入单号"
          v-model="synthesisSearch"
        ></el-input>
        <el-button type="primary" size="medium" @click="search">搜索</el-button>
      </div>
      <div class="mt10 alignCenter">
        <el-date-picker
          v-model="dataTime"
          :clearable="false"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="dataTimeChoose"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-select
          size="small"
          v-model="repositoryId"
          style="width:220px;"
          class="pl10"
        >
          <el-option
            v-for="item in repositoryList"
            :key="item.repositoryId"
            :label="item.repositoryName"
            :value="item.repositoryId"
          ></el-option>
        </el-select>
        <el-select
          size="small"
          v-model="handlerId"
          placeholder="经手人"
          class="pl10"
        >
          <el-option
            v-for="item in handlerList"
            :key="item.shopWorkerUserId"
            :label="item.fullName"
            :value="item.shopWorkerUserId"
          ></el-option>
        </el-select>
        <el-button
          type="primary"
          size="medium"
          @click="clear"
          style="margin-left:30px"
          >清除</el-button
        >
        <el-button type="primary" size="medium" @click="search">完成</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
        element-loading-text="数据正在加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column
          align="center"
          prop="orderCode"
          label="单号"
          width="220"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="repositoryName"
          label="盘点仓库"
        ></el-table-column>
        <el-table-column align="center" prop="checkStatus" label="盘点状态">
          <template slot-scope="scope">
            <div
              style="width:60px;height:30px;line-height:30px;border-radius:10px;border: 1px solid #6ABCF8;margin:auto;color:#6ABCF8;font-size:10px;"
              v-if="scope.row.checkStatus == 0"
            >
              无盈亏
            </div>
            <div
              style="width:60px;height:30px;line-height:30px;border-radius:10px;border: 1px solid #ccc;margin:auto;color:#ccc;font-size:10px;"
              v-if="scope.row.checkStatus == 1"
            >
              有盈亏
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="businessTime"
          label="业务日期"
        ></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button class="button5" @click="detail(scope.row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div v-if="tableData.length > 0" style="float:right;margin-top:10px;">
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="queryInfo.pageNo"
          :page-size="queryInfo.row"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 新增盘点 -->
    <div v-show="addChekckVisible" class="addChekckVisible">
      <div class="lock-stock-title">
        <div>新增盘点</div>
        <div>
          <img
            src="../../assets/icon/close.png"
            @click="closeAddChekck"
            class="close-img"
          />
        </div>
      </div>
      <div class="flex-row-start mt22">
        <div>盘点仓库：</div>
        <div class="checkBox" @click="chooseStock">
          <div class="checkedStock limit">{{ checkedStock }}</div>
          <div
            :class="stockListVisible == true ? 'triangle-down' : 'triangle-up'"
          ></div>
        </div>
      </div>
      <div class="stock-list" v-show="stockListVisible">
        <div
          class="lock-stock-content"
          v-for="(item, index) in repositoryLists"
          :key="index"
          @click="chooseCheckedStock(item, index)"
        >
          <div class="flex-row-start">
            <div class="limit">{{ item.repositoryName }}</div>
            <div :class="item.hadLock ? 'stock-lock' : 'stock-not-lock'">
              {{ item.hadLock }}
            </div>
          </div>
          <!-- <div><el-switch v-model="item.lockStockSwitch" @change="lockStockSwitchChange(item, index)"></el-switch></div> -->
        </div>
      </div>
      <div class="mt22">使用流程：</div>
      <div class="mt10">
        <img src="../../assets/icon/flowChart.png" class="flowChart-img" />
      </div>
      <div class="choose-goods">
        <el-button type="primary" @click="goChooseGoods">选择商品</el-button>
      </div>
    </div>
    <!-- 友情提示：该仓库未锁定，锁定后才能盘点 -->
    <div v-show="lockWarn" class="lockWarn">
      <div><img src="../../assets/icon/jjb.png" class="warn-img" /></div>
      <div class="mt22" style="color:#555;font-size:18px;">友情提示</div>
      <div class="mt22" style="color:#999;font-size:16px;">
        该仓库未锁定，锁定后才能盘点。
      </div>
      <div class="mt22">
        <el-button type="primary" plain @click="closeLookWarn"
          >暂不盘点</el-button
        >
        <el-button type="primary" @click="quickUnlock">快捷锁定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  repositoryList,
  Shop_handlerList,
  goodsCheckList,
  lockRepository,
  GoodsCheckListTotalNum
} from "../api";
export default {
  data() {
    return {
      userList: {},
      dataTime: "",
      repositoryId: "",
      repositoryList: [],
      handlerId: "",
      handlerList: [],
      tableData: [],
      queryInfo: {
        pageNo: 1,
        row: 10
      },
      total: 0,
      repositoryLists: [],
      startDate: "",
      endDate: "",
      synthesisSearch: "",
      status: "",
      visible: false,
      addChekckVisible: false,
      mask: false,
      stockListVisible: false,
      checkedStock: "",
      lockWarn: false,
      checkedStockInfo: {},
      loading: false
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    this.userList = userList;
    this.getGoodsCheckList();
    this.getRepositoryList();
  },
  methods: {
    // 快捷解锁
    quickUnlock() {
      console.log(this.checkedStockInfo);
      var index = this.repositoryLists.findIndex(item => {
        return item.repositoryId == this.checkedStockInfo.repositoryId;
      });
      console.log(index, "index", this.checkedStockInfo.repositoryId);
      if (index !== -1) {
        lockRepository({
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          isManager: 1,
          repositoryId: this.checkedStockInfo.repositoryId,
          isLock: 1
        }).then(res => {
          if (res.code == 1) {
            this.repositoryLists[index].hadLock = "已锁定";
            this.repositoryLists[index].isLock = 1;
            this.repositoryLists[index].lockStockSwitch = true;
            this.$forceUpdate();
            localStorage.setItem(
              "checkRepositoryId",
              this.checkedStockInfo.repositoryId
            );
            localStorage.setItem(
              "checkShopStoreId",
              this.checkedStockInfo.shopStoreId
            );
            this.checkedStock = this.checkedStockInfo.repositoryName;
            this.stockListVisible = false;
          }
        });
      }
      this.lockWarn = false;
      this.addChekckVisible = true;
    },
    // 选择盘点仓库并关闭
    chooseCheckedStock(item, index) {
      console.log(item);
      if (item.lockStockSwitch == false) {
        this.lockWarn = true;
        this.addChekckVisible = false;
        this.checkedStockInfo = item;
        return;
      }
      localStorage.setItem("checkRepositoryId", item.repositoryId);
      localStorage.setItem("checkShopStoreId", item.shopStoreId);
      this.checkedStock = item.repositoryName;
      this.stockListVisible = !this.stockListVisible;
    },
    // 关闭新增盘点弹框
    closeAddChekck() {
      this.addChekckVisible = false;
      this.mask = false;
      this.stockListVisible = false;
    },
    // 暂不盘点
    closeLookWarn() {
      this.lockWarn = false;
      this.mask = false;
      this.stockListVisible = false;
    },
    // 选择盘点仓库
    chooseStock() {
      this.stockListVisible = !this.stockListVisible;
    },
    // 关闭是否锁定仓库弹出层
    closePopover() {
      this.visible = false;
    },
    dataTimeChoose() {
      this.startDate = this.dataTime[0];
      this.endDate = this.dataTime[1];
    },
    // 开关的变化
    lockStockSwitchChange(item, index) {
      console.log(item, index); //是否锁定仓库 0:不锁  1:锁
      if (item.lockStockSwitch == true) {
        this.lockRepository(1, index, item.repositoryId);
      } else if (item.lockStockSwitch == false) {
        this.lockRepository(0, index, item.repositoryId);
      }
    },
    // 是否锁定仓库
    lockRepository(isLock, index, repositoryId) {
      lockRepository({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        repositoryId: repositoryId,
        isLock: isLock
      }).then(res => {
        if (res.code == 1) {
          if (this.repositoryLists[index].lockStockSwitch == true) {
            this.repositoryLists[index].hadLock = "已锁定";
            this.repositoryLists[index].isLock = 1;
            this.repositoryLists[index].lockStockSwitch = true;
          }
          if (this.repositoryLists[index].lockStockSwitch == false) {
            this.repositoryLists[index].hadLock = "";
            this.repositoryLists[index].isLock = 0;
            this.repositoryLists[index].lockStockSwitch = false;
          }
          this.$forceUpdate();
          // localStorage.setItem("repositoryLists", JSON.stringify(this.repositoryLists))
        }
      });
    },
    // 仓库
    getRepositoryList() {
      repositoryList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        isNeedAll: 1,
        pageNo: 1,
        row: 9999
      }).then(res => {
        if (res.code == 1) {
          this.repositoryList = JSON.parse(JSON.stringify(res.data));
          this.repositoryList1 = JSON.parse(JSON.stringify(res.data));
          this.repositoryList.unshift({
            repositoryId: "",
            repositoryName: "全部仓库"
          });
          this.Shop_handlerList();
          this.repositoryLists = this.repositoryList1;
          for (var i in this.repositoryLists) {
            if (this.repositoryLists[i].isLock == 1) {
              this.repositoryLists[i].lockStockSwitch = true;
              this.repositoryLists[i].hadLock = "已锁定";
            } else {
              this.repositoryLists[i].lockStockSwitch = false;
              this.repositoryLists[i].hadLock = "";
            }
          }
        }
      });
    },
    // 经手人列表
    Shop_handlerList() {
      Shop_handlerList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        pageNo: 1,
        row: 99999
      }).then(res => {
        if (res.code == 1) {
          this.handlerList = res.data[0].workers;
          this.handlerList.unshift({
            fullName: "全部经手人",
            shopWorkerUserId: ""
          });
        }
      });
    },
    // 盘点列表
    getGoodsCheckList(
      synthesisSearch,
      startDate,
      endDate,
      repositoryId,
      handlerId
    ) {
      this.loading = true;
      goodsCheckList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        pageNo: this.queryInfo.pageNo,
        row: this.queryInfo.row,
        synthesisSearch: synthesisSearch,
        startDate: startDate,
        endDate: endDate,
        repositoryId: repositoryId,
        handlerId: handlerId
      }).then(res => {
        this.loading = false;
        if (res.code == 1) {
          this.tableData = res.data;
          GoodsCheckListTotalNum({
            sessionId: this.userList.sessionId,
            userId: this.userList.id,
            isManager: 1,
            pageNo: this.queryInfo.pageNo,
            row: this.queryInfo.row,
            synthesisSearch: synthesisSearch,
            startDate: startDate,
            endDate: endDate,
            repositoryId: repositoryId,
            handlerId: handlerId
          }).then(res => {
            if (res.code == 1) {
              this.total = res.data.totalNum;
            }
          });
        } else if (res.code == -1) {
          this.tableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleSizeChange(val) {
      this.queryInfo.row = val;
      this.getGoodsCheckList();
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNo = val;
      if (this.status == 1) {
        this.getGoodsCheckList(
          this.synthesisSearch,
          this.startDate,
          this.endDate,
          this.repositoryId,
          this.handlerId
        );
      } else {
        this.getGoodsCheckList();
      }
    },
    // 搜索
    search() {
      this.queryInfo.pageNo = 1;
      this.status = 1;
      this.getGoodsCheckList(
        this.synthesisSearch,
        this.startDate,
        this.endDate,
        this.repositoryId,
        this.handlerId
      );
    },
    clear() {
      this.synthesisSearch = "";
      this.handlerId = "";
      this.repositoryId = "";
      this.dataTime = "";
      this.startDate = "";
      this.endDate = "";
      this.getGoodsCheckList();
    },
    // 选择商品
    goChooseGoods() {
      if (this.checkedStock == "") {
        this.$message.error("请先选择盘点仓库");
        return;
      }
      this.$router.push({
        path: "/invoicingFather/chooseGoods",
        query: { goodsStyle: 3 }
      });
      localStorage.setItem("goodsStyle", 3);
      // localStorage.setItem("checkedStock", this.checkedStock)
    },
    // 详情
    detail(row) {
      console.log(row);
      this.$router.push("/invoicingFather/InventoryDetail");
      sessionStorage.setItem("detailOrderid", row.orderId);
    }
  }
};
</script>

<style scoped>
.searchBox {
  width: calc(100vw - 250px);
  height: 116px;
  background: rgba(248, 248, 248, 1);
  position: absolute;
  top: 53px;
  padding: 20px;
  box-sizing: border-box;
}
.flex-row-start {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.checkBox {
  width: 317px;
  height: 30px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(217, 217, 217, 1);
  cursor: pointer;
  position: relative;
}
.checkedStock {
  line-height: 30px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(85, 85, 85, 1);
  padding-left: 17px;
  box-sizing: border-box;
}
.stock-list {
  width: 319px;
  max-height: 123px;
  overflow-y: scroll;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(217, 217, 217, 1);
  border-top: none;
  padding: 0 20px;
  box-sizing: border-box;
  position: absolute;
  z-index: 3;
  left: 100px;
}
.flowChart-img {
  width: 440px;
  height: 147px;
}
.choose-goods {
  margin-left: 74%;
  margin-top: 22px;
}
.warn-img {
  width: 68px;
  height: 68px;
}
.lockWarn {
  width: 394px;
  height: 305px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  position: absolute;
  z-index: 3;
  top: 220px;
  left: 700px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 40px 0;
  box-sizing: border-box;
}
.triangle-up {
  width: 0;
  height: 0;
  border-top: 5px solid #bfbfbf;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  position: absolute;
  right: 12px;
  top: 12px;
}
.triangle-down {
  width: 0;
  height: 0;
  border-bottom: 5px solid #bfbfbf;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  position: absolute;
  right: 12px;
  top: 12px;
}
.stock-lock {
  width: 51px;
  height: 17px;
  line-height: 17px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(248, 104, 104, 1);
  border-radius: 9px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(248, 104, 104, 1);
  text-align: center;
  margin: 15px 0 0 8px;
}
.stock-not-lock {
  background: rgba(255, 255, 255, 1);
  border: none;
}
.lock-stock {
  width: 84px;
  height: 34px;
  line-height: 34px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(16, 142, 233, 1);
  border-radius: 2px;
  display: inline-block;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(16, 142, 233, 1);
  padding-left: 6px;
  box-sizing: border-box;
  margin: 0 10px;
  cursor: pointer;
}
.lock-stock-title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #108ee9;
  color: #0482dc;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  padding-bottom: 10px;
  box-sizing: border-box;
}
.lock-stock-content {
  height: 47px;
  line-height: 47px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #e5e5e5;
  color: #333;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
.lock-stock-warn {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(247, 93, 93, 1);
  padding-top: 10px;
  box-sizing: border-box;
}
.close-img {
  width: 12px;
  height: 12px;
}
.lock-img {
  width: 15px;
  height: 15px;
  vertical-align: middle;
  margin-bottom: 3px;
}
.mt10 {
  margin-top: 10px;
}
.mt22 {
  margin-top: 22px;
}
.pl10 {
  padding-left: 10px;
  box-sizing: border-box;
}
.table {
  width: calc(100vw - 250px);
  position: absolute;
  top: 193px;
  margin-left: 20px;
}
.limit {
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.mask {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(101, 101, 101, 0.6);
}
.addChekckVisible {
  width: 498px;
  height: 429px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  position: absolute;
  z-index: 3;
  top: 220px;
  left: 500px;
  padding: 20px;
  box-sizing: border-box;
}
::v-deep .el-table th {
  background-color: #f8f8f8;
}
</style>
<style>
/* .el-table th {
    background-color: #F2F3F2;
} */
.el-popper {
  max-height: 321px !important;
  overflow-y: scroll !important;
}
/* .el-input__inner {
  height: 32px;
  line-height: 32px;
} */
</style>



// WEBPACK FOOTER //
// src/components/page/stockCheck.vue